<template>
    <div class="container">
        <div class="col-md-12">
            <h3><b><i>{{ f_titulo() }}</i></b></h3>
        </div>
        <h4>
                <input id="archivoCSV" type="file" @change="cargaCSV();showBtnHoja=true" class="btn-crear">&nbsp; 
        </h4>
        <div class="col-md-1"></div>
        <div v-if="showBtnHoja == true" class="col-md-12 row justify-content-center mt-4">
            <b-button @click="cargaFacturasSeleccionadas()" id="consult-btn">{{ labels.chargeHoja }}</b-button>
        </div>
        <div v-if="!isLoading"></div>
        <div class="loadingSpinner" :class="{ active: isLoading }">
            <b-spinner></b-spinner>
        </div>
    </div>
</template>
<script>

/* import Cargue from "../../services/Cargue"; */

export default{
name: "CargueFacturasCSV",
data: () => ({
	listVigencia: [],
	companyId: "",
	selVigencia: "",
	formato_asignado: false,
	listFacturas: [],
	listHojas: [],
	showBtnHoja: false,
	isLoading: false,
	inputArch: "",
	workbook: "",
	selectedHoja: '',
	fileReader: '',
	formato: '',
	archivo: '',
	v_error : false,
}),
computed: {
            labels(){
                if(this.$store.state._language == "es-ES"){
                    return {
                        title : "CARGUE BALANCE FORMATO EXCEL SIN INFORMACION NIIF",
                        company : "Compañía:",
                        vigencia : "Vigencia:",
                        charge : "Cargar",
                        chargeHoja : "Cargar Hoja",
			seleccione: "Seleccione.....",
			hoja: "Hoja"
                    }
                
                }else{
                    return {
                        title : "LOAD BALANCE SHEET EXCEL FORMAT WITHOUT NIIF INFORMATION",

                        company : "Company:",
                        vigencia : "Validity:",
                        charge : "Charge",
                        chargeHoja : "Charge Sheet",
			seleccione: "Select.....",
			hoja: "Sheet"


                    }
                }
            }
},
methods: {
	f_titulo() {
		let titulo = ""
		let tituloEN=""
		titulo = "PROCESO DE CARGUE DE FACTURAS(CSV)"
		tituloEN = "INVOICE UPLOAD PROCESS"
		if      (this.$store.state._language != "es-ES") {
			titulo= tituloEN
		}
		return titulo
	},
	cargaCSV() {
                const inputArch = document.getElementById("archivoCSV")
		var selectedFile=inputArch.files[0]
		this.archivo=selectedFile
		
	},
	cargaFacturasSeleccionadas() {
		this.isLoading = true;
		this.v_error = false
		let form = {
			'files'			: this.archivo,
			'idUser'        	: this.$store.state.userId
		}
		this.cargaFacturasCSV(form)
		this.isLoading = false;

	},
	cargaFacturasCSV (form) {

		let archivo='';
		let directorioCarga;



		archivo = form.files
		console.log(archivo)

		if	(!archivo) {
			this.$toast.error('Archivo '+archivo.name+' no cargado.')
		} else {
			directorioCarga = __dirname + './files/' + archivo.name
			archivo.mv(directorioCarga, function(err) {
				if	(err) {
					console.log(err)
					this.$toast.error("Error al cargar archivo")
				} else {
					this.$toast.error("Archivo Cargado!")
				}
			});
		}
	},
},
mounted(){

}
}
</script>
<style src="../main.css"></style>
